import React from "react";
import { useTranslation } from "react-i18next";
import FilterSelectList from "../../../../../components/dropDown/FilterSelectList";
import styles from "./CategorySection.module.css";
import { useEffect, useState } from "react";
import { SubCategory, Category } from "../../../../../util/ExampleData";
import { FilterSelectProps } from "../../../../../components/dropDown/FilterSelect";
import Checkbox from "../../../../../components/button/Checkbox";
import { fetchKnowledgeSummary } from "../../../../../store/categories.slice";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../store/common/hooks";

interface CategorySectionProps {
  showBackend?: boolean;
  onCategorySelect: (id: number) => void;
  onSubCategorySelect: (id: number) => void;
  defaultSelectedCategory?: number;
  defaultSelectedSubCategory?: number;
}

const CategorySection: React.FC<CategorySectionProps> = ({
  showBackend = false,
  onCategorySelect,
  onSubCategorySelect,
  defaultSelectedCategory = 0,
  defaultSelectedSubCategory = 0,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const categories = useAppSelector((s) => s.categories.categories);
  const subCategories = useAppSelector((s) => s.categories.subCategories);

  const [subCategoryOptions, setSubCategoryOptions] =
    useState<SubCategory[]>(subCategories);
  const [categoryOptions, setCategoryOptions] =
    useState<Category[]>(categories);
  const [selectedCategory, setSelectedCategory] = useState<number>(
    defaultSelectedCategory
  );
  const [selectedSubCategory, setSubSelectedCategory] = useState<number>(
    defaultSelectedSubCategory
  );
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setSubCategoryOptions(subCategories);
    setCategoryOptions(categories);
    dispatch(fetchKnowledgeSummary());
  }, [categories, subCategories]);

  useEffect(() => {
    if (selectedCategory == 0) {
      setSubCategoryOptions(subCategories);
    } else {
      const filteredSubs: SubCategory[] = subCategories.filter(
        (sub: SubCategory) => sub.category == selectedCategory
      );
      setSubCategoryOptions(filteredSubs);
    }
  }, [selectedCategory]);

  useEffect(() => {
    if (selectedSubCategory != 0) {
      const selected: SubCategory | undefined = subCategories.find(
        (sub: SubCategory) => sub.id === selectedSubCategory
      );
      const selectedCat: Category[] = categories.filter(
        (cat: Category) => cat.id == selected?.category
      );
      if (selectedCategory == 0 || selectedCategory != selected?.category) {
        setCategoryOptions(selectedCat ?? categories);
      }
    } else {
      setCategoryOptions(categories);
    }
  }, [selectedSubCategory]);

  const onCategoryChange = (id: number) => {
    setSelectedCategory(id);
    onCategorySelect(id);
  };

  const onSubCategoryChange = (id: number) => {
    setSubSelectedCategory(id);
    onSubCategorySelect(id);
  };

  const handleCheckboxChange = (checked: boolean) => {
    setChecked(checked);
  };

  const data: FilterSelectProps[] = [
    {
      hint: t("createNewButton.category"),
      options: categoryOptions,
      onChange: onCategoryChange,
      classNameStyle: styles["category_view"],
      selectedId: defaultSelectedCategory,
    },
    {
      hint: t("createNewButton.subcategory"),
      options: subCategoryOptions,
      onChange: onSubCategoryChange,
      classNameStyle: styles["category_view"],
      selectedId: defaultSelectedSubCategory,
    },
  ];
  return (
    <div className={styles["category-row"]}>
      <FilterSelectList data={data} />
      {showBackend && (
        <div className={styles["rightcol"]}>
          <Checkbox checked={checked} onChange={handleCheckboxChange} />
          <p>Backend</p>
        </div>
      )}
    </div>
  );
};

export default CategorySection;
